// Import model
import { DataviewRoomResponse } from '../models/DataviewRoomResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterRoomRequest } from '../models/FilterRoomRequest';
import { Room } from '../models/Room';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterRoomRequestSerializer } from './FilterRoomRequestSerializer';
import { RoomSerializer } from './RoomSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewRoomResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewRoomResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewRoomResponse instance
   */
  static deserialize(json: string): DataviewRoomResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewRoomResponse instance
   */
  static fromObject(obj: any): DataviewRoomResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewRoomResponse');
    }


    const instance: DataviewRoomResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        RoomSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterRoomRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewRoomResponse instances
   */
  static deserializeArray(json: string): DataviewRoomResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewRoomResponse instance to a JSON string
   */
  static serialize(instance: DataviewRoomResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewRoomResponse instance to a plain object
   */
  static toObject(instance: DataviewRoomResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        RoomSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterRoomRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewRoomResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewRoomResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
